import { stripOuterLiteraryQuotes } from "../utils/literaryExcerpt";
import "./LiteraryExcerpt.css";

const OPEN_CURLY_QUOTE = "\u201C";
const CLOSE_CURLY_QUOTE = "\u201D";

export default function LiteraryExcerpt({ text, className = "" }) {
  const content = stripOuterLiteraryQuotes(text);
  if (!content) return null;

  return (
    <span className={`literary-excerpt ${className}`.trim()}>
      <span className="literary-excerpt__quote" aria-hidden="true">
        {OPEN_CURLY_QUOTE}
      </span>
      {content}
      <span className="literary-excerpt__quote" aria-hidden="true">
        {CLOSE_CURLY_QUOTE}
      </span>
    </span>
  );
}
